import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { errorDemoApi } from '../api/errorDemoApi';
import type { ErrorCatalogResponse, ApiError } from '../types/errorDemo';

/**
 * Query: GET /api/eraf/error-demo/codes
 * Auto-fires on page mount.
 * p95 target < 100ms (in-memory catalog, no DB).
 *
 * R7-085: queryKey includes current locale so that switching ko/en
 * triggers a fresh fetch with the updated Accept-Language header,
 * causing the BE to return messages in the new locale without a
 * manual page reload.
 */
export function useErrorCodes() {
  const { i18n } = useTranslation();
  const lang = i18n.language ?? 'ko';
  return useQuery<ErrorCatalogResponse, ApiError>({
    queryKey: ['error-demo', 'codes', lang],
    queryFn: () => errorDemoApi.getCatalog(),
    retry: false,
    staleTime: 60_000,
  });
}
